import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'privacy-policy-modal',
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.css'],
})
export class PrivacyPolicyModalComponent implements OnInit {
  public showPrivacyPolicy = false;

  ngOnInit(): void {
    const agreedToPrivacyPolicy: Boolean =
      window.localStorage.getItem('agreedToPrivacyPolicy') === 'true';
    if (!agreedToPrivacyPolicy) this.showPrivacyPolicy = true;
  }

  agreeToPrivacyPolicy = (): void => {
    window.localStorage.setItem('agreedToPrivacyPolicy', 'true');
    this.showPrivacyPolicy = false;
  };
}
